







import * as Gdpr from '@/model';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'Paragraph',
})
export default class Paragraph extends Vue {
  @Prop({ default: { t: '', p: []} }) private data!: Gdpr.Paragraph;

  private get t(): string {
    return Gdpr.HtmlEncode(this.data.t);
  }

}
